<template>
    <div>
        <h1 class="pb-4 font-weight-lighter text-center">دليلكم الشامل</h1>
        <h6 class="pb-12 text-center">
            يرجى إدخال البريد الإلكتروني لإستعادة <br />
            <span class="text-secondary pt-2 d-inline-block">كلمة المرور</span>
        </h6>
        <label for="email">إيميل</label>
        <v-text-field
            id="email"
            rounded
            dense
            filled
            color="secondary"
            v-model="reset_by.email"
        ></v-text-field>
        <label for="support">أوالإستعادة عن طريق الدعم الفني</label>
        <v-text-field
            id="support"
            color="secondary"
            rounded
            dense
            filled
            v-model="reset_by.support"
        ></v-text-field>
        <div class="text-center pt-8">
            <v-btn class="pt-5 pb-4 px-8" color="gray" rounded>تم</v-btn>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        reset_by: {
            email: "",
            support: ""
        }
    })
};
</script>
